// src/components/steps/Plan.jsx
import React, { useState, useRef, useEffect } from "react";
import AddonsApi from "../../api/bff/src/api/AddonsApi";
import ApiClient from "../../api/bff/src/ApiClient";
import config from "../../config/properties.json";
import BasketsApi from "../../api/bff/src/api/BasketsApi";
import { default as content } from '../../content/en'
import { ScaleLoader } from "react-spinners";
import Space from "../Space";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

// Define plans (no diff between physical SIM and eSIM)
// const plans = Plans

const apiClient = new ApiClient(config.apiBaseUrl);
const addOnsApi = new AddonsApi(apiClient);
const plans = await addOnsApi.addonsGet();
const basketsApi = new BasketsApi(apiClient);


function formatPriceWithFrequency(plan) {
  if (!plan || !plan.price) return "";

  const frequency =
    plan.validity > 1
      ? plan.validity + " " + plan.validityUnit
      : plan.validityUnit.replace(/s$/, "");

  const cost = (plan.costUnit === "cents" || plan.costUnit === "pence")
    ? plan.price / 100 // Convert cents/pence to pounds
    : plan.price;

  return "£" + cost.toFixed(2) + " / " + frequency.toLowerCase();
}

function formatPrice(plan) {
  if (!plan || !plan.price) return "";

  const cost = (plan.costUnit === "cents" || plan.costUnit === "pence")
    ? plan.price / 100 // Convert cents/pence to pounds
    : plan.price;

  return "£" + cost.toFixed(2);
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1800 },
    items: 4
  },
  smdesktop: {
    breakpoint: { max: 1800, min: 1200 },
    partialVisibilityGutter: 30,
    items: 3
  },
  lgtablet: {
    breakpoint: { max: 1200, min: 1000 },
    partialVisibilityGutter: 100,
    items: 2
  },
  tablet: {
    breakpoint: { max: 1000, min: 860 },
    partialVisibilityGutter: 50,
    items: 2
  },
  lgmobile3: {
    breakpoint: { max: 860, min: 815 },
    partialVisibilityGutter: 25,
    items: 2
  },
  lgmobile2: {
    breakpoint: { max: 815, min: 755 },
    partialVisibilityGutter: 5,
    items: 2
  },
  lgmobile: {
    breakpoint: { max: 755, min: 650 },
    partialVisibilityGutter: -40,
    items: 2
  },
  mobile3: {
    breakpoint: { max: 650, min: 570 },
    partialVisibilityGutter: 100,
    items: 1
  },
  mobile2: {
    breakpoint: { max: 570, min: 505 },
    partialVisibilityGutter: 70,
    items: 1
  },
  mobile: {
    breakpoint: { max: 505, min: 450 },
    partialVisibilityGutter: 30,
    items: 1
  },
  smmobile: {
    breakpoint: { max: 450, min: 0 },
    items: 1
  }
};

export default function Plan({
  next,
  prev,
  setUserPlan,
  planPrice,
  setPlanPrice,
  customerSelections,
  setCustomerSelections,
  basket,
  setBasket,
  simType,
  setSimType,
  preSelectedPlan
}) {
  const [selected, setSelected] = useState(plans[0].id);
  const isMobile = window.innerWidth <= 850;
  const cardWidth = isMobile ? 160 : 200;
  const [submitClicked, setSubmitClicked] = useState(false);
  const [preSelectedPlanIsValid, setPreSelectedPlanIsValid] = useState(null);

  async function selectPlanAndProceed() {
    setSubmitClicked(true);
    const serviceItems = [{ productId: selected }];
    const basketsPostRequest = {
      channel: config.channel
    }

    const basket = await basketsApi.basketsPost({ basketsPostRequest });
    setBasket(basket);
    next(); // Proceed to next step
  }

  // center selected card
  useEffect(() => {
    let idx = -1
    if (preSelectedPlan !== null && preSelectedPlanIsValid === null) {
      idx = plans.findIndex((p) => p.name === preSelectedPlan);
      if (idx !== -1) {
        setSelected(plans[idx].id);
        setPreSelectedPlanIsValid(true);
      } else {
        setPreSelectedPlanIsValid(false);
      }
    } else {
      idx = plans.findIndex((p) => p.id === selected);
    }
    if (idx !== -1) {
      setUserPlan(plans[idx]);
      setPlanPrice(plans[idx].price);
      setCustomerSelections({
        ...customerSelections,
        ["Select Plan"]: {
          stepDescription: plans[idx].name + " (" + formatPrice(plans[idx]) + ")",
          /*stepDetails: "Automated renewals, but cancel anytime!!!!!!",*/
        },
        ["Provide Payment"]: {
          stepDescription: plans[idx].price,
          /*stepDetails: "Automated renewals, but cancel anytime!!!!!!",*/
        },
      })
    }
    if (preSelectedPlanIsValid) {
      selectPlanAndProceed();
    }

    // handle browser back button
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);

  }, [selected, plans, preSelectedPlanIsValid]);

  return (
    <>
      { preSelectedPlanIsValid &&
        <>
        <div className="scaleloader-processing">
          <ScaleLoader
            color="#f36d13"
            size={200}
            loading={true}
            cssOverride={{
              justifySelf: "center",
              display: "block",
            }} />
        </div>
        <Space height={48} />

        <div className="card">
          <div className="step-header">
            <h2>{content.orderCreation.h2}</h2>
          </div>
          <div style={{ padding: 24 }}>
            <br />
            <p>{content.orderCreation.processingMessage} {preSelectedPlan}</p>
            <br />
          </div>
        </div>
        </>
      }
      { (preSelectedPlan === null || (preSelectedPlan !== null && (preSelectedPlanIsValid !== null && !preSelectedPlanIsValid))) &&
        <>
          <div className="card no-breadcrumb centered">
            <div className="step-header">
              <h2>{content.plans.h2}</h2>
            </div>

            <div style={{ postion: "relative", padding: "24px" }}>
              <Carousel
                responsive={responsive}
                itemClass="carouselItem"
                centerMode={false}
                partialVisible={true}
                infinite={true}
                minimumTouchDrag={30}
              >
                {plans.map((p) => (
                  <div
                    key={p.id}
                    className="plan-banner"
                    onClick={() => setSelected(p.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setSelected(p.id)
                      }
                    }
                    }
                    style={{
                      border:
                        p.id === selected
                          ? "2px solid #FF6600"
                          : "2px solid transparent",
                      backgroundImage: p.imageURL ? `url(${p.imageURL})` : "none",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover"
                    }}
                    tabIndex="0"
                  >
                    <div className="plan-title">{p.name}</div>
                    <div className="plan-price">{formatPriceWithFrequency(p)}</div>
                    <div className="plan-description">{p.description}</div>
                  </div>
                ))}
              </Carousel>
            </div>

            <div className="plan-footer">
              <div className="plan-inclusions">
                <ul>
                  <li><p className="plan-inclusion-items">{content.plans.footer.inclusionItem1}</p></li>
                  <li><p className="plan-inclusion-items">{content.plans.footer.inclusionItem2}</p></li>
                  <li><p className="plan-inclusion-items">{content.plans.footer.inclusionItem3}</p></li>
                  <li><p className="plan-inclusion-items">{content.plans.footer.inclusionItem4}</p></li>
                </ul>
              </div>
              <button onClick={selectPlanAndProceed} className="button button-primary" disabled={submitClicked}>
                {content.plans.submit}
              </button>
            </div>
          </div>
        </>
      }
    </>
  );
}
